import { UserPermissionAction } from "avvir";
import { usePermissionService } from "./use_permission_service";
import { useMemo } from "react";

export function useProjectPermission(action: UserPermissionAction, fallback?: boolean, forceEnableCheck?: boolean): boolean {
  const service = usePermissionService();
  return useMemo(() => {
    return service.isPermittedForCurrentProject(action, fallback, forceEnableCheck);
  }, [action, service, fallback, forceEnableCheck]);
}
